import React from 'react';
import { Check as CheckIcon } from '@mui/icons-material';
import { Typography, Box } from '@mui/material';
import { TFunction } from 'react-i18next';
import { StrengthPasswordType } from 'services/auth';

function StrengthPassword({
  t,
  checkResult,
  password,
}: {
  t: TFunction<('_common' | 'change_password' | 'api_errors')[], undefined>;
  checkResult: StrengthPasswordType;
  password: string;
}) {
  return (
    <Box>
      {checkResult.hasFragility ? (
        <>
          {checkResult.fragilities.map((item) => (
            <Box
              key={item?.key}
              sx={{
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  bgcolor: item?.done ? 'grey.300' : 'error.main',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  mr: 1,
                  display: 'inline-block',
                }}
              />
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  textDecoration: item?.done ? 'line-through' : 'none',
                  textDecorationColor: 'text.secondary',
                }}
              >
                {item?.T}
              </Typography>
            </Box>
          ))}
        </>
      ) : password ? (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <CheckIcon sx={{ color: 'success.main' }} />
          <Typography variant="caption" color="text.secondary">
            {t('change_password:safe_password')}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default StrengthPassword;
